<template>
    <button
        class="popover__option"
        :class="{ 'btn-strip': props.inline, 'strip-btn': !props.inline }"
        :disabled="isThrobbing || isRouting"
        @click.stop="handleClick"
        v-if="$page.props.auth.user || props.loggedIn"
    >
        <span class="icon">
            <icon-option-bookmark-filled
                v-if="isBookmarked"
            ></icon-option-bookmark-filled>
            <icon-option-bookmark
                v-else-if="!isBookmarked"
            ></icon-option-bookmark>
        </span>
        <span
            class="label"
            :style="{ visibility: isThrobbing ? 'hidden' : 'visible' }"
            >{{ statusText }}</span
        >
        <Throbber v-if="isThrobbing" />
    </button>
    <Link
        :href="route('login')"
        class="popover__option strip-btn"
        title="Login to Save Lists"
        v-else
        >Login to Save Lists</Link
    >
</template>
<script setup>
import { computed, inject } from "vue";
import { Link, usePage } from "@inertiajs/vue3";
import IconOptionBookmark from "~/svg/ui-option-bookmark.svg";
import IconOptionBookmarkFilled from "~/svg/ui-option-bookmark-filled.svg";
import Throbber from "@/utilities/Throbber.vue";
import { useCardOptionsMenuStore } from "@/stores/cardOptionsMenu";
import { useInertiaAction } from "@/composables/useInertiaAction.js";

const route = inject("route");

// Props
const props = defineProps({
    loggedIn: {
        type: Boolean,
        default: false,
    },
    list: {
        type: Object,
        default: null,
    },
    inline: {
        type: Boolean,
        default: false,
    },
    isRouting: {
        type: Boolean,
        default: false,
    },
});

// Stores
const cardOptionsStore = useCardOptionsMenuStore();

// Computed
const isBookmarked = computed(() => props.list.is_bookmark ?? false);

const isBookmarksView = computed(() => {
    return usePage().component === "MyGiftHero/Bookmarks";
});

const statusText = computed(() => {
    return isBookmarked.value
        ? "Remove from Saved Lists"
        : "Add to Saved Lists";
});

// Busy spans the request and the follow-up reload (GH-1159) so the option
// lands in its new state instead of flashing back first.
const { busy: isThrobbing, run: runBookmark } = useInertiaAction();

/**
 * Toggle the bookmark, then refresh the props the current view reads.
 */
async function handleClick() {
    const only =
        isBookmarked.value && isBookmarksView.value
            ? ["bookmarks"]
            : ["giftlist"];
    const request = () =>
        isBookmarked.value
            ? axios.delete(
                  route("bookmark.destroy", { giftlist: props.list.uuid }),
              )
            : axios.post(
                  route("bookmark.create", { giftlist: props.list.uuid }),
              );

    await runBookmark(request, { only, preserveScroll: false });

    cardOptionsStore.closeAll();
}
</script>
